export default {"src":"/_next/static/media/arrow_white.cb0aa4bb.svg","height":15,"width":43};